import { render, staticRenderFns } from "./EvaluationsJoined.vue?vue&type=template&id=2c865306&scoped=true"
import script from "./EvaluationsJoined.vue?vue&type=script&lang=js"
export * from "./EvaluationsJoined.vue?vue&type=script&lang=js"
import style0 from "./EvaluationsJoined.vue?vue&type=style&index=0&id=2c865306&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c865306",
  null
  
)

export default component.exports